import { ContactCenterLogo } from '@components/ContactCenterLogo';
import { StackItem, BodyText, Stack } from '@servicetitan/design-system';
import { useRouteError } from 'react-router-dom';

const ErrorPage = () => {
  const error = useRouteError() as any;
  console.error(error);

  return (
    <Stack
      alignContent='center'
      className='h-100vh'
      direction='column'
      justifyContent='center'
      spacing={4}
    >
      <StackItem alignSelf='center'>
        <ContactCenterLogo showIcon />
      </StackItem>
      <StackItem alignSelf='center' className='ta-center'>
        <BodyText bold size='large' className='m-b-2'>
          An error has occured!
        </BodyText>
        <BodyText className='m-t-half c-red'>
          {error.statusText || error.message}
        </BodyText>
      </StackItem>
    </Stack>
  );
};

export default ErrorPage;
